import React from "react";
import ReactDOM from "react-dom";
import BaseComponent from "./BaseComponent";

export default class Submenu extends BaseComponent {
    /**
     * Submenu container with positioning logics
     * @module Submenu
     * @param {Object} props React props
     */
    constructor(props){
        super(props);
        this.state = {
            content: this.props.content ? this.props.content : DefaultSubmenu,
            asSubcontext: this.props.hasOwnProperty("asSubcontext")
        };
        this.clickOutsideHandler = this.handleClickOutside.bind(this);
    }

    /**
     * Get reference to submenu itself
     * @returns {jQuery}
     */
    getDomSelf(){
        return $(ReactDOM.findDOMNode(this));
    }

    /**
     * Position the submenu based on parent DOM context upon mount
     */
    componentDidMount() {
        document.addEventListener('mousedown', this.clickOutsideHandler);
        document.addEventListener('wheel', this.clickOutsideHandler, { passive: false });

        const dWidth = $(window).width();
        const dHeight = $(window).height();
        const eTop = this.props.domContext.getDomSelf().offset().top - $(window).scrollTop();
        const eLeft = this.props.domContext.getDomSelf().offset().left - $(window).scrollLeft();

        var top = 0, left = 0;
        // Top
        if (eTop <= dHeight / 2){
            top = eTop - 10;
        } else {
            top = eTop - this.getDomSelf().height() + 1.5 * this.props.domContext.getDomSelf().height();
        }
        if (this.state.asSubcontext){
            top = eTop;
        }

        // Triangle position
        const topTri = eTop - top + this.props.domContext.getDomSelf().height() / 2;
        this.getDomSelf().append('<style>.submenu-overlay:before{top: ' + topTri + 'px !important;}</style>');

        // Left
        if (this.props.domContext.getDomSelf().offset().left <= dWidth / 2){
            left = eLeft + this.props.domContext.getDomSelf().outerWidth() + 15;
            this.getDomSelf().addClass("left");
        } else {
            left = eLeft - this.getDomSelf().outerWidth() - 15;
            this.getDomSelf().addClass("right");
        }
        if (this.state.asSubcontext){
            left = eLeft + this.props.domContext.getDomSelf().outerWidth();
            this.getDomSelf().removeClass("left").removeClass("right");
        }

        this.getDomSelf().css({
            top: top,
            left: left,
            visibility: "visible"
        }).animateCss("fadeIn");
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.clickOutsideHandler);
        document.removeEventListener('wheel', this.clickOutsideHandler);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.props.domContext.removeSubmenu();
        }
    }

    /**
     * React render
     * @returns {XML}
     */
    render(){
        // Instantiate submenu content view
        const Content = this.state.content;
        return (
            <div className={(() => {
                     if (this.state.asSubcontext){
                         return "submenu-overlay subcontext";
                     }
                     return "submenu-overlay";
                 })()}
                 ref={this.setWrapperRef.bind(this)}>
                <Content context={this.props.context} domContext={this.props.domContext} data={this.props.data}
                         params={this.props.params} readOnly={this.props.readOnly}/>
            </div>
        );
    }
}

/**
 * Default submenu view with empty content
 * @class DefaultSubmenu
 */
class DefaultSubmenu extends BaseComponent {
    /**
     * @param {Object} props React props
     */
    constructor(props){
        super(props);
    }

    /**
     * React render
     * @returns {XML}
     */
    render(){
        return (<div style={{textAlign: "center"}}><label><em>{this.getPropLabel("no_submenu")}</em></label></div>);
    }
}